const NetworkError = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="flex items-center justify-center pt-10 bg-gray-100 px-4">
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md w-full text-center">
        <div className="text-6xl mb-4 text-red-500">🌐</div>
        <h1 className="text-2xl font-semibold mb-2">Network Error</h1>
        <p className="text-gray-600 mb-6">
          It seems you're offline or the connection was lost.
          <br />
          Please check your internet and try again.
        </p>
        <button
          onClick={handleRetry}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export { NetworkError };
